export default __webpack_public_path__ + "static/media/ujjawal.ecb04730.png";